/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_Tab_AvailabilityInputs */



/**
* | output |
* | --- |
* | "Availability" |
*
* @param {Connectivity_History_Tab_AvailabilityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_tab_availability = /** @type {((inputs?: Connectivity_History_Tab_AvailabilityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Tab_AvailabilityInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Availability")
	return /** @type {LocalizedString} */ ("Disponibilité")
});